import { store } from 'react-notifications-component';
import 'animate.css';

class NotificationHandler {

    notificationHandler(title : String, message : React.ReactElement, type : any, duration: number,){
    
        return store.addNotification({
            title: title,
            message: message,
            type: type,
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__backInRight"],
            animationOut:["animate__animated","animate__backOutRight"],
            dismiss: {
              duration: duration,
              onScreen: true,
              click: true,
              pauseOnHover: true,
              showIcon: true,
            }
          });
    }
}



export default NotificationHandler;